<template>
  <div class="page-box">
    <div class="page-content">
      <transition name="el-zoom-in-top">
        <div class="left-menu-box" v-if="!isShrink">
          <div class="school_index_top_box" @click="goHome()">
            <img src="@/assets/img/logo/logo2.png" alt="" />
            <!-- <img src="@/assets/img/schoolIndex/anen-icon.png" alt="" /> -->
            <!-- <div>双重预防体系云平台</div> -->
          </div>
          <div class="segmentation-line-box"></div>
          <div class="menu-box">
            <el-menu
              :default-active="defaultActive"
              background-color="#0C193D"
              text-color="#fff"
              active-text-color="#409EFF"
              unique-opened
            >
           
              <el-submenu
                v-for="(item, index) in menuList"
                :key="index"
                :index="item.index"
              >
                <template slot="title">
                  <!-- <i class="el-icon-location"></i> -->
                  <div class="icon">

                    <img v-if="item.icon" class="icon-img" :src="item.icon" />
              <!-- <img class="icon-img"  v-if="item.icon" :src="thisLeftMenu.includes(item.path)? item.act_icon:item.icon" />  -->

                  </div>
                  <span>{{ item.menuName }}</span>
                </template>
                <div  class="secondSubMenu" v-for="(iitem, iindex) in item.subMenuList" :key="iindex">
                  <el-submenu v-if="iitem.list.length > 0" :index="iitem.index">
                    <template slot="title">
                      <!-- userInfo.eduBuresuType==-1 -->
                      <!-- <template v-if="userInfo.eduBuresuType!=0 ">
                        <el-icon :class="iitem.icon"></el-icon>
                      </template>
                      <template v-else>  -->
                        <img class="icon-img"  v-if="iitem.icon" :src="iitem.icon" /> 
                      <!-- </template> -->


                      <!-- thisLeftMenu.includes(iitem.path)? iitem.act_icon: -->
                      <!-- <i class="el-icon-location"></i> -->
                      <span>{{ iitem.name }}</span></template
                    >
                    <el-menu-item-group v-if="iitem.list.length > 0">
                      <el-menu-item

                        v-for="(iiitem, iiindex) in iitem.list"
                        :key="iiindex"
                        :index="iiitem.index"
                        @click="pagePush(iiitem)"
                      >
                        <template slot="title">
                          <div style="margin-left: 14px;padding-left: 6px; position: relative;">


                            <!-- <template v-if="userInfo.eduBuresuType!=0 ">
                              <el-icon :class="iiitem.icon"></el-icon>
                            </template>
                            <template v-else>  -->
                              <img v-if="thisLeftMenu.includes(iiitem.path)" src="@/assets/img/user/thirdFocus.png" style="width: 10px;height: auto;position: absolute;left: 0;
                                  bottom: 0;top:0;margin: auto; left: -10px;" alt="">
                            <!-- </template> -->
                         
                            <span style="">{{ iiitem.name }}</span>
                          </div></template
                        >
                      </el-menu-item>
                    </el-menu-item-group>
                  </el-submenu>
                  <el-menu-item :index="iitem.index" v-else @click="pagePush(iitem)">
                    <div style=" font-size: 14px;margin-left: 0">
                      <!-- <i class="el-icon-location"></i> -->
                      <img class="icon-img"  v-if="iitem.icon" :src="thisLeftMenu.includes(iitem.path)? iitem.act_icon:iitem.icon" /> 
                      <span>{{ iitem.name }}</span>
                    </div>
                  </el-menu-item>
                </div>
              </el-submenu>
              <el-tooltip class="item" effect="dark" content="可视化隐患整改+社会化评议" placement="right-start">
               <el-menu-item @click="goCustomVideo()" index="video">
                <template slot="title">
                  <div style="font-size: 14px">
                    <div class="icon" style="margin-right: 0;"> 
                      <img  v-if="thisLeftMenu.includes('Visualization')" src="@/assets/customvideo_1.png" alt="">
                      <img  v-else src="@/assets/customvideo.png" alt="">
                    </div>
                       <span  :style="thisLeftMenu.includes('Visualization')?'color:rgb(64, 158, 255)':''">
                        可视隐患+社评 
                      </span>
                  </div></template>
              </el-menu-item> 
              </el-tooltip>
              <el-menu-item @click="goMeeting()" index="home">
                <template slot="title">
                  <div style="font-size: 14px">
                    <div class="icon" style="margin-right: 0;">
                      <img  v-if="thisLeftMenu.includes('cloud_meeting')" src="@/assets/img/menu/meeting2.png" alt="">
                      <img  v-else src="@/assets/img/menu/meeting3.svg" alt="">
                    </div>
                    <span  :style="thisLeftMenu.includes('cloud_meeting')?'color:rgb(64, 158, 255)':''">
                      云上会议
                    </span>
                  </div></template
                >
              </el-menu-item> 
            </el-menu>
          </div>
        </div>
      </transition>
      <!-- <div class="shrink-box el-icon-arrow-left"></div> -->
      <!-- 
              :style="'z-index:' + (100 - index)" -->
      <div class="content-box" ref="contentBoxRef">
        <div class="title-box">
          <!-- <div v-if="assistantMenuList.length == 0 && !isShrink" @click="shrinkClick" class=" shrink-box el-icon-arrow-left"></div>
          <div v-if="assistantMenuList.length == 0 && isShrink" @click="shrinkClick" class=" shrink-box el-icon-arrow-right"></div> -->
          <transition name="el-zoom-in-left">
            <div class="assistant-menu-list-box" v-if="assistantMenuList.length > 0">
              <div
                v-for="(item, index) in assistantMenuList"
                :key="index"
                @click="assistantClick(item, index)"
                :style="selectIndex <= index ? 'left:-20px' : ''"
                :class="
                  routePath == item.path
                    ? 'pitch-on assistant-menu-item-box'
                    : 'un-pitch-on assistant-menu-item-box'
                "
              >
                <div
                  v-if="routePath == item.path && index != 0"
                  class="placeholder-box"
                ></div>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </transition>
          <transition name="el-zoom-in-center">
            <div class="title-content-box" v-if="assistantMenuList.length == 0"  @click="goHome()">
              <img src="@/assets/img/user/home.png" style="color:#06112F;width:20px ;margin-right: 5px;"  alt=''>
              <!-- <el-icon class="el-icon-s-home" style="color:#06112F;font-size: 15px;margin-right: 5px;"></el-icon> -->
                  返回首页
            </div>
          </transition>
          <div class="title-user-box">
            <!-- <el-link href="https://school.zzsasoft.com/uploads/layui/2023.04.12.docx" type="primary" target="_blank">信息统计表下载</el-link> -->
            <!-- <div
              class="el-icon-full-screen icon-box"
              style="width: 25px; height: 25px; margin: 0px 20px"
              @click="$Common.full()"
            ></div> -->
            
            <img src="@/assets/img/user/screen.png"  @click="$Common.full()" style="width:24px;height:auto;cursor:pointer;" alt="">
            
            <!-- <el-divider></el-divider> -->
            <!-- <el-badge
              class="item"
              :hidden="messagesNumber == 0 ? true : false"
              :value="messagesNumber"
            >
           <span style="width: 1px;height: 26px;display: inline-block;border: 1px solid #e5e5e5; margin: 0 30px;margin-top:6px;"></span>
            
            </el-badge> -->
          <img src="@/assets/img/user/notice.png" style="width:24px;height:auto;margin-left:30px;" alt="">
             <el-badge
              class="item"
              :hidden="messagesNumber == 0 ? true : false"
              :value="messagesNumber"
            >
           <span style="width: 1px;height: 26px;display: inline-block;border: 1px solid #e5e5e5; margin: 0 30px;margin-top:6px;"></span>
            
            </el-badge>
            <!-- <span style="width: 1px;height: 13px;display: inline-block;border: 1px solid #414141;opacity: 0.2;margin: 0 10px;"></span> -->

            <el-dropdown trigger="click">
              <div class="icon-box" >
                <img
                  style="width: 25px; height: 25px"
                  v-if="userInfo.headPortrait"
                  :src="$store.state.config.fileUrl + userInfo.headPortrait"
                />
                <img style="width: 25px; height: 25px" v-else src="@/assets/avatar.png" />
                <div class="" style="margin: 0 10px;">
                  {{ schoolInfo.schoolName }} 
                </div>
                <el-icon class="el-icon-caret-bottom"></el-icon>
              </div>
              <el-dropdown-menu slot="dropdown" style="padding: 0px">
                <div class="user-name-box">{{ userInfo.userName }}</div>
                <el-dropdown-item
             

                  @click.native="$Common.loginOut()"
                  >   <img  src="@/assets/img/user/1.png" style="width:20px;height:auto;margin-right:6px;" /> 切换账号</el-dropdown-item
                >
                <el-dropdown-item
                  v-if="userInfo.roleId == -1"
                 
                  @click.native="routeSkip('/schoolData')"
                  > <img  src="@/assets/img/user/2.png" style="width:20px;height:auto;margin-right:6px;" />  学校资料</el-dropdown-item
                >
                <el-dropdown-item  @click.native="appDownLoad"
                  > <img  src="@/assets/img/user/3.png" style="width:20px;height:auto;margin-right:6px;" />  应用下载</el-dropdown-item
                >
                <el-dropdown-item
                 
                  @click.native="routeSkip('/situation_editor')"
                >
                <img  src="@/assets/img/user/4.png" style="width:20px;height:auto;margin-right:6px;" />   <span>数据编辑</span>
                </el-dropdown-item>
                <el-dropdown-item
                 
                  @click.native="showPop"
                  > <img  src="@/assets/img/user/5.png" style="width:20px;height:auto;margin-right:6px;" />  单位绑定</el-dropdown-item
                >
                <el-dropdown-item
                  
                  @click.native="routeSkip('/advice_feedback')"
                  > <img  src="@/assets/img/user/6.png" style="width:20px;height:auto;margin-right:6px;" />  在线帮助</el-dropdown-item
                >
                <el-dropdown-item  @click.native="LoperationGuide"
                  > <img  src="@/assets/img/user/7.png" style="width:20px;height:auto;margin-right:6px;" />  操作指南</el-dropdown-item
                >
                <el-dropdown-item  @click.native="add"
                  > <img  src="@/assets/img/user/8.png" style="width:20px;height:auto;margin-right:6px;" />  自动生成</el-dropdown-item
                >
                <el-dropdown-item @click.native="$Common.loginOut()">
                  <img  src="@/assets/img/user/9.png" style="width:20px;height:auto;margin-right:6px;" />   <span>退出登录</span>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </div>
        <div class="content-content-box">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <el-dialog
    title="单位列表"
    :visible.sync="dialogVisible"
    width="80%"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    append-to-body
  >
    <div class="content">
      <el-input placeholder="根据单位ID模糊查询" v-model="unitID" class="input-with-select">
    
        <el-button slot="append" type="primary" @click="showPop" icon="el-icon-search"></el-button>
      </el-input>
      <div class="edu_table_box">
            <el-table
              v-loading="tableLoading"
              :header-cell-style="{ background: '#DDE4FF', color: '#474859' }"
              :data="dataList.list"
              height="100%"
              class="table_box"
            >
              <el-table-column label="序号" width="70" align="center">
                <template slot-scope="scope">
                  {{
                    dataList.pageSize * (dataList.pageNo - 1) + scope.$index + 1
                  }}
                </template>
              </el-table-column>
              <el-table-column label="单位ID" prop="unitID" width="300" align="center">
               
              </el-table-column>
              <el-table-column
                prop="unitName"
                label="单位名称"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="location"
                label="地址"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                prop="remark"
                label="备注"
                align="center"
                show-overflow-tooltip
              >
              </el-table-column>
              <el-table-column
                
                prop="createTime"
                label="创建时间"
                align="center"
                show-overflow-tooltip
              >
              
              </el-table-column>
             
              <el-table-column label="操作" width="180" align="center">
                <template slot-scope="rowData">
                  <el-link
                    type="primary"
                    @click="bindUnit(rowData.row)"
                    :underline="false"
                    >绑定学校</el-link
                  >
                 
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="edu_pagination_box">
            <el-pagination
              @current-change="handleCurrentChange"
              background
              :current-page="dataList.pageNo"
              :page-sizes="[20, 50, 100, 200]"
              :page-size="dataList.pageSize"
              layout="total, prev, pager, next, jumper"
              :total="dataList.total"
            >
            </el-pagination>
          </div>
    </div>
  </el-dialog>
    <!-- <notice-message></notice-message> -->
    <template-create :addResize="addResize"></template-create>
  </div>
</template>

<script>
//这里可以引入其他文件（比如组件，工具js，第三方插件js，json文件，图片文件等等）
//列如：import <<组件名称>> from '《组件路径》';
import "../../../public/css/school_pages.scss";
import NoticeMessage from "../../components/NoticeMessage.vue";
import TemplateCreate from "../../components/NoticeTemplateCreate.vue";
// import screenfull from "screenfull";
import screenfull from "screenfull";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    NoticeMessage,
    TemplateCreate
  },
  props: {},
  data() {
    //这里存放数据
    return {
      menuList: [],
      defaultActive: "0-0",
      assistantMenuList: [], //副级菜单列表
      selectIndex: 2,
      routePath: this.$route.path,
      isShrink: false,
      indexMenu: "",
      addResize: 0,
      dialogVisible:false,
      unitID:"",
      dataList:{
        pageNo:1,
        pageSize:10,
        total:0
      },
      tableLoading:false
    };
  },
  //监控data中的数据变化
  watch: {
    isSafeInfo: function (val) {
      if (!val) {
        this.getPosture();
      } else {
        this.getInfo();
      }
    },
    $route: function (val) {
      if (val.path == "/broadcastController" || val.path == "/broadcastEquipment") {
        this.routePath = "/broadcast_binding";
      } else if (val.path == "/apartmentRooms" || val.path == "/apartmentPersons") {
        this.routePath = "/apartmentBuilding";
      } else if (val.path == "/drill_record") {
        this.routePath = "/emergency_plan";
      } else {
        this.routePath = val.path || "";
      }
    },
  },
  //计算属性，类似于data概念
  computed: {
    userInfo() {
      return this.$store.getters.getUserInfo;
    },
    thisLeftMenu() {
      return this.$route.path;
    },
    schoolInfo() {
      return this.$store.state.schoolInfo;
    },
    isSafeInfo() {
      return this.$store.state.isSafeInfo;
    },
    messagesNumber() {
      return this.$store.state.messagesNumber;
    },
    schoolBidDataVersion() {
      return this.$store.state.schoolBidDataVersion;
    },
  },
  //方法集合
  methods: {
    getInfo() {
      let data = [];
      console.log(this.userInfo.eduBuresuType)
      if (this.userInfo.eduBuresuType == -1) {
        data = this.$store.state.menu.menuListAccount;
        this.indexMenu = this.$store.state.menu.indexMenuCollege;
      } else {
        data = this.$store.state.menu.menuListTwo;
        this.indexMenu = this.$store.state.menu.indexMenu;
      }
      this.dataOption(data);
    },
    getPosture() {
      if (this.userInfo.eduBuresuType == -1) {
        this.indexMenu = this.$store.state.menu.indexMenuCollege;
      } else {
        this.indexMenu = this.$store.state.menu.indexMenu;
      }
      let data = this.indexMenu.slice(1);
      this.dataOption(data);
    },
    dataOption(data) {
      this.menuList = data.map((item, index) => {
        item.index = index + "";
        item.subMenuList = item.subMenuList.map((iitem, iindex) => {
          iitem.index = index + "-" + iindex;
          if (iitem.list) {
            iitem.list = iitem.list.map((iiitem, iiindex) => {
              iiitem.index = index + "-" + iindex + "-" + iiindex;
              return iiitem;
            });
          }
          return iitem;
        });
        return item;
      });
      this.defaultActive = this.$store.state.pathIndex || "0-0";
      this.assistantMenuList = this.$store.state.pathArr || [];
    },
    pagePush(info) {
      if (info.path == "/drill_center" || info.path == "/safeposture_school"||info.path == "/CloudDrillCenter" ) {
        let routeUrl = this.$router.resolve({
          path: info.path,
        });
        window.open(routeUrl.href, "_blank");
      } else {
        // console.log(info.path);
        sessionStorage.setItem("thisTopPagePath", info.path);
        this.$router.push(info.path);
      }
      this.$store.commit("updatePathIndex", info.index);
      this.assistantMenuList = info.sublevelList || [];
      this.$store.commit("updatePathArr", this.assistantMenuList);
    },
    goHome() {
      this.$store.commit("updatePathIndex", "0-0");
      this.$store.commit("updatePathArr", []);
      let path = "/schoolIndex_" + this.schoolBidDataVersion;
      this.$router.push(path);
    },
    newHome(){
      this.$store.commit("updatePathIndex", "home");
      this.assistantMenuList = [];
      this.$router.push('/newHome');
    },
    assistantClick(info, index) {
      this.$router.push(info.path);
      if (index > 1) {
        this.selectIndex = index;
      }
    },
    getTimeState() {
      let date = new Date();
      if (date.getHours() >= 6 && date.getHours() < 12) {
        return "上午好！";
      } else if (date.getHours() >= 12 && date.getHours() < 18) {
        return "下午好！";
      } else {
        return "晚上好！";
      }
    },
    appDownLoad() {
      let routeUrl = this.$router.resolve({
        path: "app_downLoad",
      });
      window.open(routeUrl.href, "_blank");
    },
    LoperationGuide() {
      window.open(
        "https://school.zzsasoft.com/uploads/files/20200511/%E5%B9%B3%E5%8F%B0%E6%93%8D%E4%BD%9C%E6%8C%87%E5%8D%97.pdf",
        "_blank"
      );
    },
    add() {
      this.addResize++;
    },
    routeSkip(route) {
      this.$store.commit("updatePathArr", []);
      this.assistantMenuList = [];
      this.$Common.pageJump(route, 1);
    },
    shrinkClick() {
      if (!this.isShrink) {
        // 展开状态，点击后关闭
        setTimeout((this.$refs.contentBoxRef.className = "content-box-two"), 1000);
      } else {
        // 关闭状态，点击后展开
        this.$refs.contentBoxRef.className = "content-box";
      }
      this.isShrink = !this.isShrink;
    },
    showPop(){
      let req = {
        pageNo:this.dataList.pageNo,
        pageSize:this.dataList.pageSize,
        unitID:this.unitID
      }
      this.tableLoading=true
      this.$Http.getUnitList(req).then(res=>{
        console.log(res)
        this.dataList =res.data
        this.tableLoading=false
        this.dialogVisible=true

      })
    },
    handleCurrentChange(e){
      this.dataList.pageNo=e
        this.showPop()
    },
    bindUnit(item){
      this.$confirm("确定要绑定该学校吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.$Http.bindUnit({
        schoolId:this.schoolInfo.schoolId,
        schoolName:this.schoolInfo.schoolName,
        unitName:item.unitName,
        unitId:item.unitID
      }).then(res=>{
        console.log(res)
        if(res.code==200){
          this.$message({
            type: "success",
            message:'绑定成功'
          });
        }else{
          this.$message({
            type: "warning",
            message: res.messsage
          });
          
        }
      })
        })
        .catch(() => {
          console.log(111);
          this.$message({
            type: "info",
            message: "已取消"
          });
        });
      
      
    },
    goMeeting(){
      this.$router.push('/cloud_meeting')
    },  
    goCustomVideo(){
      this.$router.push('/Visualization')

    },
    goCourse(){
            this.$router.push('/small_course')

    }
  },
  //生命周期，创建完成（可以访问当前this实例）
  created() {
    if (this.isSafeInfo) {
      this.getInfo();
    } else {
      this.getPosture();
    }
    this.$Common.getNoticesNumber(1);
  },
  //生命周期，挂载完成（可以访问dom元素）
  mounted() {},
  beforeCreate() {}, //生命周期-创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之后
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroy() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
@import "/css/base.css";
@import "/css/index.css";
@import "/css/campus_security.css";
@font-face {
    font-family: 'MPPlus-midium';
    src: url('~@/assets/MP-plus.ttf') format('truetype');
}
@font-face {
    font-family: 'MPPlus-light';
    src: url('~@/assets/MPLUSRounded1c-Light.ttf') format('truetype');
}
@font-face {
    font-family: 'MPPlus-regular';
    src: url('~@/assets/MPLUSRounded1c-Regular.ttf') format('truetype');
}
.page-box {
  width: 100%;
  height: 100%;
}
.page-content {
  width: 100%;
  height: 100%;
  background: #F7F8FA;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
}
.left-menu-box {
  width: 186px;
  height: 100%;
  //background: #1f2956;
  position: relative;
}

.icon {
  display: inline-block;
  width: 20px;
  text-align: center;
  margin-right: 5px;
  position: relative;
  top: -2px;
  .img-icon {
    display: inline-block;
  }
}
.shrink-box {
  width: 20px;
  height: 100%;
  background-color: #1f2956;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.school_index_top_box {
  width: calc(100% - 1px);
  height: 60px;
  background: rgb(12, 25, 61);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  border-radius: 0 10px 0 0;
  cursor: pointer;
  img {
    margin-top: 10px;
    width: 108px;
    height: auto;
    position: relative;
    // left: -6px;
  }
  div {
    margin: 14px 0px 14px 10px;
    line-height: 17px;
    height: 17px;
    font-size: 17px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 700;
    color: #3D3D3D;    letter-spacing: 3px;
  }
}
.segmentation-line-box {
  width: calc(100% - 1px);
  height: 10px;
  background: rgb(12, 25, 61);
 
}
.menu-box {
  width: calc(100% - 1px);
  height: calc(100% - 70px);
  overflow-y: scroll;
  scrollbar-width: none;
  background: rgb(12, 25, 61);
  
  border-radius: 0 0 10px 0;
  font-family: 'MPPlus-regular';
}
.menu-box::-webkit-scrollbar{
  width: 0 !important;height: 0; 
 
}
.content-box {
  width: calc(100% - 186px);
  height: 100%;
  background: #F7F8FA;
  .title-box {
    // width: 100%;
    height: 75px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    // margin-right: 20px;
    background-color: #fff;
    position: relative;
    margin: 15px 15px 0;
    box-shadow: 0px 0px 6px 0px rgba(0,84,254,0.11);
    border-radius: 12px;
  }
  .content-content-box {
    margin: 10px 15px 0 15px;
    width: calc(100% - 30px);
    height: calc(100% - 100px);
    // background-color: #fff;
  }
}
.content-box-two {
  width: 100%;
  height: 100%;
  .title-box {
    width: 100%;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    margin-right: 20px;
    background-color: #fff;
    position: relative;
    
  }
  .content-content-box {
    margin: 10px;
    width: calc(100% - 20px);
    height: calc(100% - 80px);
    // background-color: #fff;
  }
}
.title-content-box {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  // font-weight: 600;
  // font-family: AlibabaPuHuiTiB;
  // letter-spacing: 20px;
  width: 90px;
  height: 24px;
  line-height: 1;
  font-size: 15px;
  color: #4d5154;
  // background: #F1F3F7;
  border-radius: 12px 12px 12px 12px;
    position: relative;
    margin-left: 23px;
//   &::before{
//     position: absolute;
//     clear: both;
//     content:"";
//     left: -23px;
//     width: 1px;
// height: 31px;
// border: 1px solid;
// border-image: linear-gradient(180deg, rgba(240.00000089406967, 243.00000071525574, 247.00000047683716, 0.2800000011920929), rgba(183.95623058080673, 213.10253620147705, 251.96428209543228, 1), rgba(240.00000089406967, 243.00000071525574, 247.00000047683716, 0.33000001311302185)) 1 1;
//   }
}

.title-user-box {
flex: 1;
  height: 100%;
  right: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  font-weight: 400;
font-size: 16px;
color: #4d5154;
  .icon-box {
    // width: 200px;
    margin: 0 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    cursor: pointer;
    color: #4d5154;
            img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
    }
  }
}
.assistant-menu-list-box {
  position: absolute;
  left: 0px;
  top: calc(50% - 20px);
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  .assistant-menu-item-box {
    width: 120px;
    height: 100%;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  // 选中
  .pitch-on {
    color: #fff;
    background: radial-gradient(circle at left, transparent, transparent, #7eacf1 32px);
    // background: #1f6ce0;
    box-shadow: 4px 0px 8px 0px rgba(37, 162, 215, 0.2);
    border-radius: 0px 38px 38px 0px;
    // position: relative;
    // left: -20px;
    // width: 136px;
    // background: url("~@/assets/img/schoolOptionIcon/menu-pitch-on-icon.png");
    // background-size: 100% 100%;
    &:nth-child(1) {
      background: #7eacf1;
    }
    // &:nth-child(2) {
    //   width: 136px;
    //   left: -20px;
    // }
  }
  // 未选中
  .un-pitch-on {
    color: #999999;
    box-shadow: 9px 0px 17px 0px rgba(40, 153, 202, 0.33);
    border-radius: 0px 38px 38px 0px;
    // position: relative;
    // left: -20px;
    // &:nth-child(1) {
    //   left: 0px;
    // }
  }
}
.user-name-box {
  width: 100%;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  // font-weight: bold;
  color: #606266;
  background-color: #f7f7f7;
}
.content{
  height: 550px;
}
.edu_table_box{
  height: 450px;
  margin: 10px 0;
}
.icon-img{
  width: 16px;
  height: auto;
  margin-right: 6px;
}
/deep/.left-menu-box  .is-active{
    background-color: #172C66!important;
}
.secondSubMenu{
  overflow: hidden;
}
/deep/.secondSubMenu .el-submenu__title{
  padding-left: 24px!important;
}
/deep/.secondSubMenu .el-menu-item{
    padding-left: 24px!important;

}
</style>
